module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-005"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Further reading")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("P. Hacking, "), _c('i', [_vm._v("Isaiah")]), _vm._v(", Crossway Bible Guides (Crossway, 1994) is good for group study.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("B. Webb, "), _c('i', [_vm._v("The Message of Isaiah")]), _vm._v(", The Bible Speaks Today (IVP, 1996) is full of insight and application, excellent for personal study.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("D. Kidner, ‘Isaiah’, in "), _c('i', [_vm._v("The New Bible Commentary, twenty-first century Edition ")]), _vm._v("(IVP, 1994). Brilliant for a ‘first run through’ of Isaiah. Full of perceptiveness.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("J. N. Oswalt, "), _c('i', [_vm._v("The Book of Isaiah 1 – 39 ")]), _vm._v("(Eerdmans, 1986) offers a very full treatment in the manner of a standard commentary, with discussion of contrasting opinions and patient unravelling of problems. Volume 2 is eagerly awaited.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("J. A. Motyer, "), _c('i', [_vm._v("The Prophecy of Isaiah ")]), _vm._v("(IVP, 1993) is a more demanding ‘read’ than either the present commentary or Oswalt. Delves into literary and poetic structure as a tool for displaying meaning and message. Take it slowly!")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("David Stacey, "), _c('i', [_vm._v("Isaiah 1 – 39 ")]), _vm._v("(Epworth, 1993). A gracious and helpful study, and a good introduction to the ‘multiple-authorship’ view of Isaiah.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("P. D. Miscall, "), _c('i', [_vm._v("Isaiah ")]), _vm._v("(JSOT Press, 1993) is like reading from 1:1 – 66:24 in the company of a marvellously well-informed friend who knows how to stop over key words and phrases and to explain how they ‘work’ in their differing contexts in Isaiah. A gold-mine!")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("E. J. Young, "), _c('i', [_vm._v("The Book of Isaiah ")]), _vm._v("(Eerdmans, 1965) is massively ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("conservative. Young’s chief expertise was as a linguist, and especially in this area his commentary is of great value.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("J. Skinner, "), _c('i', [_vm._v("Isaiah")]), _vm._v(", 2 vols. (CUP, 1902, 1905) holds to ‘three Isaiahs’. He rarely fails to say something illuminating and helpful in his careful verse-by-verse writing.")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("J. D. Smart, "), _c('i', [_vm._v("History and Theology in Second Isaiah ")]), _vm._v("(Epworth, 1967), and U. E. Simon, "), _c('i', [_vm._v("A Theology of Salvation, Isaiah 40 – 55 ")]), _vm._v("(SPCK, 1953), adopt ‘running commentary’ styles with deep insights into the movement of the prophet’s thought.")])])])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31094265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre6.vue
// module id = 78
// module chunks = 0